/** Matches the percent formatting used elsewhere in DMS: a plain space before the sign. */
export const formatBatteryCharge = (value: number): string => `${value} %`;
